// extracted by mini-css-extract-plugin
module.exports = {"alert":"wYjjUxyor6UHsDjFnez7"};